import ccpdAuditPdf from "../../../assets/tenders/RFP for CCPD Audit 2026.pdf";

const tenderPdfContext = require.context(
  "../../../assets/tenders",
  false,
  /\.pdf$/,
);

const tenderPdfFiles = tenderPdfContext.keys().map((key) => ({
  fileName: key.replace("./", ""),
  href: tenderPdfContext(key),
}));

const getTenderPdf = (fileName = "") =>
  tenderPdfFiles.find((pdf) => pdf.fileName === fileName) || {
    fileName,
    href: "",
  };

const careerTenderPdfContext = require.context(
  "../../../assets/career_pdf",
  false,
  /\.pdf$/,
);

const careerTenderPdfFiles = careerTenderPdfContext.keys().map((key) => ({
  fileName: key.replace("./", ""),
  href: careerTenderPdfContext(key),
}));

const getCareerTenderPdf = (fileName = "") =>
  careerTenderPdfFiles.find((pdf) => pdf.fileName === fileName) || {
    fileName,
    href: "",
  };

const eventManagementTenderDocuments = [
  {
    serial: 1,
    title: "EMPANELMENT OF EVENT MANAGEMENT AGENCIES-EMAs",
    fileName: "EMPANELMENT OF EVENT MANAGEMENT AGENCIES-EMAs.pdf",
  },
  {
    serial: 2,
    title: "Corrigendum of tender for empanelment of Event Management Agencies (EMA)",
    fileName:
      "Corrigendum of tender for empanelment of Event Management Agencies (EMA).pdf",
  },
].map((document) => {
  const pdf = getCareerTenderPdf(document.fileName);

  return {
    ...document,
    fileName: pdf.fileName,
    href: pdf.href,
  };
});

const socioEconomicImpactTenderDocuments = [
  {
    serial: 1,
    title:
      "Notice inviting tenders for conducting Socio Economic Impact Study of beneficiaries financed under various schemes",
    fileName:
      "Notice inviting tenders for conducting Socio Economic Impact Study of beneficiaries financed under various schemes of NMDFC.pdf",
  },
  {
    serial: 2,
    title: "Corrigendum 2",
    fileName: "Corrigendum 2.pdf",
  },
  {
    serial: 3,
    title:
      "Corrigendum of tender for inviting proposals for conducting Impact Study 2022",
    fileName:
      "Corrigendum of tender for inviting proposals for conducting Impact Study 2022.pdf",
  },
].map((document) => {
  const pdf = getCareerTenderPdf(document.fileName);

  return {
    ...document,
    fileName: pdf.fileName,
    href: pdf.href,
  };
});

const websiteRedesignTenderDocuments = [
  {
    serial: 1,
    title:
      "Redesigning and Maintenance of the Official Website for One Year",
    fileName:
      "Redesigning and Maintenance of the Official Website of NMDFC for One Year.pdf",
  },
  {
    serial: 2,
    title:
      "Corrigendum of tender for Redesigning and Maintenance of the Official Website",
    fileName:
      "Corrigendum of tender for Redesigning and Maintenance of the Official Website of NMDFC.pdf",
  },
].map((document) => {
  const pdf = getCareerTenderPdf(document.fileName);

  return {
    ...document,
    fileName: pdf.fileName,
    href: pdf.href,
  };
});

const archiveTenderDetails = [
  {
    title: "Manpower Outsourcing Services",
    publishDate: "16 Oct, 2025 05:27 PM",
    lastDate: "27 Oct, 2025 04:00 PM",
    fileName: "16 Oct,2025 to 27 Oct,2025 .pdf",
  },
  {
    title:
      "Open Tender for Appointment of Audit Firms for Conducting Internal Audit for the Financial Year 2025-26",
    links: ["Corrigendum 1"],
    publishDate: "19 Sep, 2025 06:30 PM",
    lastDate: "07 Oct, 2025 10:00 AM",
    fileName: "19 Sep,2025 to 07 Oct,2025 .pdf",
  },
  {
    title: "Hiring of Consultant -Marketing & Finance",
    publishDate: "08 Sep, 2025 06:02 PM",
    lastDate: "23 Sep, 2025 11:59 PM",
    fileName: "08 Sep,2025 to 23 Sep,2025 .pdf",
  },
  {
    title:
      "REQUEST FOR PROPOSAL (RFP) For Engagement of Transactional Advisor For Modifications / Improvement in Schemes / Programmes, Introduction of New Schemes / Products, and Change in Business Model",
    links: ["Corrigendum 1", "Corrigendum 2"],
    publishDate: "29 Aug, 2025 04:06 PM",
    lastDate: "16 Sep, 2025 02:00 PM",
    fileName: "29 Aug,2025 to 16 Sep,2025 .pdf",
  },
  {
    title:
      "Request for Quota on for Engagement of Web Accessibility Auditor for Website",
    publishDate: "30 Jul, 2025 04:42 PM",
    lastDate: "14 Aug, 2025 06:00 PM",
    fileName: "30 Jul,2025 to 14 Aug,2025 .pdf",
  },
  {
    title: "Lok Samvardhan Parv, Kochi",
    publishDate: "18 Jul, 2025 05:23 PM",
    lastDate: "07 Aug, 2025 02:00 PM",
    fileName: "18 Jul,2025 to 07 Aug,2025 .pdf",
  },
  {
    title:
      "LIMITED TENDER FOR SELECTION OF KVIC EMPANELLED EVENT MANAGEMENT AGENCY",
    links: ["Corrigendum 1"],
    publishDate: "30 May, 2025 10:53 PM",
    lastDate: "04 Jun, 2025 03:00 PM",
    fileName: "30 May,2025 to 04 Jun,2025 .pdf",
  },
  {
    title:
      "OPEN TENDER FOR SELECTION OF EVENT MANAGEMENT AGENCY FOR DESIGNING, FABRICATION AND BRANDING OF SPACE & SETTING UP OF STALLS, STAGE & PAVILION OF MINISTRY OF MINORITY AFFAIRS, GOI. LOCATED AT VETERINARY COLLEGE GROUND, KHANAPARA, G.S ROAD, GUWAHATI, ASSAM",
    publishDate: "20 May, 2025 11:42 AM",
    lastDate: "03 Jun, 2025 02:30 PM",
    fileName: "20 May,2025 to 03 Jun,2025 .pdf",
  },
  {
    title:
      "OPEN TENDER FOR SELECTION OF EVENT MANAGEMENT AGENCY FOR DESIGNING, FABRICATION AND BRANDING OF SPACE & SETTING UP OF STALLS, STAGE & PAVILION OF MINISTRY OF MINORITY AFFAIRS, GOI. LOCATED AT CONVOCATION GROUND, KASHMIR UNIVERSITY, SRINAGAR, UNION",
    publishDate: "20 Mar, 2025 05:43 PM",
    lastDate: "24 Mar, 2025 11:00 AM",
    fileName: "20 Mar,2025 to 24 Mar,2025 .pdf",
  },
  {
    title:
      "OPEN TENDER FOR SELECTION OF EVENT MANAGEMENT AGENCY (BEING ORGANISED FROM 5th APRIL TO 13th APRIL 2025 LOCATED AT KASHMIR UNIVERSITY GROUNDS, SRINAGAR, UT of J&K)",
    links: ["Corrigendum 1"],
    publishDate: "07 Mar, 2025 08:59 AM",
    lastDate: "17 Mar, 2025 02:00 PM",
    fileName: "07 Mar,2025 to 17 Mar,2025 .pdf",
  },
  {
    title:
      "EOI for Appointment of Audit firms for Conducting Internal Audit for Financial Year 2024-25",
    publishDate: "25 Jan,2024 03:00 PM",
    lastDate: "06 Feb,2024 04:00 PM",
    fileName: "25 Jan,2024 to 06 Feb,2024 .pdf",
  },
  {
    title:
      "BID for Engaging PCS Firm for the work relating to Company Secretariat Section for the remaining period of FY 2023-24 & FY 2024-25",
    publishDate: "09 Jan,2024 05:45 PM",
    lastDate: "17 Jan,2024 02:00 PM",
    fileName: "09 Jan,2024 to 17 Jan,2024 02-00 PM.pdf",
  },
  {
    title:
      "EOI for Appointment of Audit firms for Conducting Internal Audit for Financial Year 2024-25",
    publishDate: "04 Jan,2024 05:35 PM",
    lastDate: "15 Jan,2024 04:00 PM",
    fileName: "04 Jan,2024 05-35 PM to 15 Jan,2024 04-00 PM.pdf",
  },
  {
    title:
      "Quotation for Repairing/addition/alternation/extension/merging of Conference/ Meeting Room",
    publishDate: "01 Dec,2023 03:40 PM",
    lastDate: "12 Dec,2023 03:39 PM",
    fileName: "01 Dec,2023 03-40 PM to 12 Dec,2023 03-39 PM.pdf",
  },
  {
    title:
      "Limited Tender for Selection of Event Management Agency for Organising 'Awareness Generation Program for Schemes of MOMA'",
    publishDate: "07 Oct,2023 12:00 AM",
    lastDate: "10 Oct,2023 12:00 AM",
    fileName: "07 Oct,2023 12-00 AM to 10 Oct,2023 12-00 AM.pdf",
  },
  {
    title:
      "NIT-INVITATION FOR BID FOR ENGAGEMENT/EMPANELMENT OF ADVOCATE/SENIOR ADVOCATE/LAW FIRM FOR LEGAL SERVICES.",
    publishDate: "06 Sep,2023 12:00 AM",
    lastDate: "22 Sep,2023 12:00 AM",
    fileName: "06 Sep,2023 12-00 AM to 22 Sep,2023 12-00 AM.pdf",
  },
  {
    title:
      "NOTICE INVITING TENDER INVITATION FOR BID FOR ENGAGEMENT/EMPANELMENT OF ADVOCATE/SENIOR ADVOCATE/LAW FIRM FOR LEGAL SERVICES",
    publishDate: "15 Jun,2023 12:00 AM",
    lastDate: "03 Jul,2023 12:00 AM",
    fileName: "15 Jun,2023 12-00 AM to 03 Jul,2023 12-00 AM.pdf",
  },
  {
    title: "EMPANELMENT OF EVENT MANAGEMENT AGENCIES-EMAs",
    publishDate: "16 Sep,2022 12:00 AM",
    lastDate: "17 Mar,2022 12:00 AM",
    fileIcon: "link",
    detailDocuments: eventManagementTenderDocuments,
  },
  {
    title: "Invitation to Limited Tender for Conducting of Online Test for recruitment",
    publishDate: "16 Sep,2022 12:00 AM",
    lastDate: "21 Jul,2022 12:00 AM",
    fileName: "16 Sep,2022 12-00 AM to 21 Jul,2022 12-00 AM.pdf",
  },
  {
    title:
      "Notice inviting tenders for conducting Socio Economic Impact Study of beneficiaries financed under various schemes.",
    publishDate: "13 Sep,2022 12:00 AM",
    lastDate: "28 Sep,2022 12:00 AM",
    fileIcon: "link",
    detailDocuments: socioEconomicImpactTenderDocuments,
  },
  {
    title:
      "Notice Inviting Limited Tender From NICSI empanelled Tier II vendors For Modifications in MIS Portal.",
    publishDate: "18 Aug,2022 12:00 AM",
    lastDate: "25 Aug,2022 12:00 AM",
    fileName: "18 Aug,2022 12-00 AM to 25 Aug,2022 12-00 AM.pdf",
  },
  {
    title:
      "Notice Inviting Limited Tender From NICSI empanelled Tier III vendors For Modifications in MIS Portal",
    publishDate: "18 Aug,2022 12:00 AM",
    lastDate: "25 Aug,2022 12:00 AM",
    fileName: "18 Aug,2022 12-00 AM to 25 Aug,2022 12-00 AM (1).pdf",
  },
  {
    title:
      "Extension of Tender Notice No. 631 dated 8th August 2022 NILT for Redesigning and Maintenance of the Official Website.",
    publishDate: "17 Aug,2022 12:00 AM",
    lastDate: "30 Aug,2022 12:00 AM",
    fileName: "17 Aug,2022 12-00 AM to 30 Aug,2022 12-00 AM.pdf",
  },
  {
    title: "Redesigning and Maintenance of the Official Website for One Year",
    publishDate: "08 Aug,2022 12:00 AM",
    lastDate: "16 Aug,2022 12:00 AM",
    fileIcon: "link",
    detailDocuments: websiteRedesignTenderDocuments,
  },
  {
    title: "Inviting proposal for Development of Banking Software and Mobile App",
    publishDate: "16 Jun,2022 12:00 AM",
    lastDate: "27 Jun,2022 12:00 AM",
    fileName: "16 Jun,2022 12-00 AM to 27 Jun,2022 12-00 AM.pdf",
  },
  {
    title: "Engagement of Young Professionals (YPs)",
    publishDate: "14 Jun,2022 12:00 AM",
    lastDate: "29 Jun,2022 12:00 AM",
    fileName: "14 Jun,2022 12-00 AM to 29 Jun,2022 12-00 AM.pdf",
  },
  {
    title:
      "RFP for inviting proposals for Socio Economic Impact Study of beneficiaries financed",
    publishDate: "31 May,2022 12:00 AM",
    lastDate: "15 Jun,2022 12:00 AM",
    fileName: "31 May,2022 12-00 AM to 15 Jun,2022 12-00 AM.pdf",
  },
  {
    title:
      "Request For Proposal (RFP) for Development of Real Time Governance System (RTGS)",
    publishDate: "03 May,2022 12:00 AM",
    lastDate: "18 May,2022 12:00 AM",
    fileName: "03 May,2022 12-00 AM to 18 May,2022 12-00 AM.pdf",
  },
  {
    title:
      "Open Tender for Appointment of firms of Chartered Accountants for Internal Control over Financial Reporting (ICFR) for Financial Year 2021-22",
    publishDate: "26 Apr,2022 12:00 AM",
    lastDate: "09 May,2022 12:00 AM",
    fileName: "26 Apr,2022 12-00 AM to 09 May,2022 12-00 AM.pdf",
  },
  {
    title:
      "LIMITED TENDER DOCUMENT FOR SELECTION OF EMAs ALREADY EMPANELLED WITH MAEF FOR ORGANSING CULTURAL PROGRAMS AT SHIV TEMPLE COMPLEX, RATHONDA, MILAK RAMPUR, UP",
    publishDate: "26 Feb,2022 12:00 AM",
    lastDate: "02 Mar,2022 12:00 AM",
    fileName: "26 Feb,2022 12-00 AM to 02 Mar,2022 12-00 AM.pdf",
  },
  {
    title:
      "LIMITED TENDER FOR SELECTION OF EVENT MANAGEMENT AGENCY ALREADY EMPANELLED WITH MAEF",
    publishDate: "17 Feb,2022 12:00 AM",
    lastDate: "23 Feb,2022 12:00 AM",
    fileName: "17 Feb,2022 12-00 AM to 23 Feb,2022 12-00 AM.pdf",
  },
  {
    title: "Proposal for Kaushal se Kushalta Scheme",
    publishDate: "28 Jan,2022 12:00 AM",
    lastDate: "14 Feb,2022 12:00 AM",
    careerFileName: "Proposal for Kaushal se Kushalta Scheme.pdf",
  },
  {
    title: "Tender for disposal of old, obsolete, unserviceable items from reputed firms/persons",
    publishDate: "18 Oct,2021 12:00 AM",
    lastDate: "25 Oct,2021 12:00 AM",
    fileName: "18 Oct,2021 12-00 AM to 25 Oct,2021 12-00 AM.pdf",
  },
  {
    title:
      "OPEN TENDER FOR SELECTION OF EVENT MANAGEMENT AGENCY FOR ORGANISING MUSHAIRA/KAVI SAMMELAN ON ATMA NIRBHAR BHARAT ABHIYAN",
    publishDate: "25 Jan,2021 12:00 AM",
    lastDate: "10 Feb,2021 12:00 AM",
    careerFileName: "87OPEN TENDER FOR SELECTION.pdf",
  },
  {
    title:
      "LIMITED TENDER FOR SELECTION OF EVENT MANAGEMENT AGENCY ALREADY EMPANELLED WITH MAEF.",
    publishDate: "15 Jan,2021 12:00 AM",
    lastDate: "22 Jan,2021 12:00 AM",
    fileName: "15 Jan,2021 12-00 AM to 22 Jan,2021 12-00 AM.pdf",
  },
  {
    title: "Tender Notice",
    publishDate: "01 Jan,2021 12:00 AM",
    lastDate: "01 Apr,2021 12:00 AM",
    fileName: "01 Jan,2021 12-00 AM to 01 Apr,2021 12-00 AM.pdf",
  },
  {
    title:
      "Open Tender for Selection of Creative Agency for Handling & Managing Twitter & Social Media Account",
    publishDate: "07 Jan,2021 12:00 AM",
    lastDate: "27 Jan,2021 12:00 AM",
    fileName: "07 Jan,2021 12-00 AM to 27 Jan,2021 12-00 AM.pdf",
  },
];

export const activeTenders = [
  {
    serial: 1,
    title: "Engagement of Web Accessibility Auditor for NMDFC Website, Web Applications and Integrated AI Chatbot",
    publishDate: "07 Oct 2026",
    lastDate: "—",
    fileName: "RFP for CCPD Audit 2026.pdf",
    href: ccpdAuditPdf,
  },
];

export const archiveTenders = archiveTenderDetails.map((tender, index) => {
  const pdf = tender.careerFileName
    ? getCareerTenderPdf(tender.careerFileName)
    : getTenderPdf(tender.fileName);

  return {
    serial: index + 1,
    ...tender,
    fileName: pdf.fileName,
    href: pdf.href,
  };
});
